
const CountDownSquare = ({ label, number, cardRef }) => {
  return (
    <div className="countdown__card mx-5 md:mx-3">
      <div className="countdown__card__bg" ref={cardRef}>
        <div className="countdown__card__number" id={label}>
          {number}
        </div>
      </div>
      <div className="countdown__card__label">{label}</div>
    </div>
  );
};

export default CountDownSquare;
